import { Controller } from "@hotwired/stimulus";
import RailsNestedForm from "@stimulus-components/rails-nested-form";

// Connects to data-controller="nested-form"
export default class extends RailsNestedForm {
  connect() {
    this.wrapperSelectorValue = ".nested-form-wrapper";

    super.connect();
  }
}
